<!-- src/components/CarCard.vue -->
<template>
    <div class="car-card" @click="$emit('click')">
        <div class="car-image-container">
            <img 
                v-if="car.images && car.images.length > 0"
                :src="car.images[0]" 
                :alt="`${car.make} ${car.model}`"
                class="car-image"
            />
            <div v-else class="no-image">{{ $t('no_image_available') }}</div>
        </div>
        <div class="car-info">
            <h3>{{ car.make }} {{ car.model }}</h3>
            <p class="year-mileage">{{ car.year }} • {{ $n(car.mileage, 'number') }} {{ $t('kilometers') }}</p>
            <p class="price">{{ $n(car.price, 'currency') }}</p>
            <div class="specs">
                <span>{{ $t(`fuel_types.${car.fuel_type.toLowerCase()}`) }}</span>
                <span>{{ car.power_kw }} {{ $t(`car_power.kilowatts`) }} / {{ calculateHorsepower(car.power_kw) }} {{ $t(`car_power.horse_power`) }}</span>
                <span>{{ $t(`transmissions.${car.transmission.toLowerCase()}`) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        car: {
            type: Object,
            required: true
        }
    },
    emits: ['click'],
    methods: {
        navigateToCar() {
            this.$emit('click')
        },

        calculateHorsepower(kw) {
            return Math.trunc(parseInt(kw) * 1.34102); 
        }
    }
}
</script>

<style scoped>
.car-card {
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgb(168 168 168 / 44%);
    background: white;
}

.car-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.car-image-container {
    height: 180px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.car-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.no-image {
    color: #666;
    font-size: 0.9rem;
}

.car-info {
    padding: 1.25rem;
}

.car-info h3 {
    margin: 0 0 0.5rem 0;
    font-size: 1.1rem;
    color: #333;
}

.year-mileage {
    color: #666;
    font-size: 0.9rem;
    margin: 0 0 0.75rem 0;
}

.price {
    font-weight: bold;
    font-size: 1.2rem;
    margin: 0 0 0.75rem 0;
    color: #45ABFF;
}

.specs {
    display: flex;
    gap: 0.75rem;
    font-size: 0.8rem;
    color: #666;
}
</style>